import { useNavigate } from "react-router-dom";
import { WebRoutes } from "../routes/WebRoutesPath";
import { useState, useEffect } from "react";
import FallBackLoader from "../components/FallBackLoader";

const Error = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    // Simulate a loading delay (e.g., fetching data or other setup)
    setTimeout(() => {
      setIsLoading(false);
    }, 2000); // Adjust the time as needed

    // Include actual loading logic here
  }, []);
  if (isLoading) {
    return <FallBackLoader />;
  }
  return (
    <div className="error-bg">
      <div className="container error">
        <div className="error-bg-overlay">
          <div className="d-flex flex-column justify-content-center align-items-center pt-4">
            <img
              src={require("../assets/images/error2.png")}
              width="250px"
              alt=""
            />
            <h3>404 - PAGE NOT FOUND</h3>
          </div>
          <div className="d-flex flex-column justify-content-center align-items-center mt-5">
            <p className="text-center fs-4 font-500 px-5 my-2">
              THE PAGE YOU ARE LOOKING FOR IS NOT FOUND
            </p>
            <p className="text-center w-100 px-5 mx-5 fs-4">
              The page you are looking for does not exist. It may have been
              moved, or removed altogether. Perhaps you can return back to the
              site’s homepage and see if you can find what you are looking for.
            </p>
            <div className="d-flex justify-content-around flex-column flex-lg-row my-4">
              <div
                className="btn-border hover-effect font-500 cursor-pointer m-1 d-flex align-items-center justify-content-center"
                onClick={() => navigate(-3)}
              >
                Reload Last Visited Page
              </div>
              <div
                className="btn-border hover-effect font-500 cursor-pointer m-1 d-flex align-items-center justify-content-center"
                onClick={() => navigate(WebRoutes.Home)}
              >
                BACK TO HOMEPAGE
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Error;
